import {useStores} from "../Hooks";
import {responseEnum} from "../serverClientShared/sharedEnums"

const SaveFileHook = () => {
    const {modalStore, generalStore, projectStore, procedureStore, dragStore} = useStores();

    async function onUploadFilesSuccess(files) {
        dragStore.selectedFilesIds = new Set();
        files.forEach(file => {
            dragStore.selectedFilesIds.add(file.FileId);
            dragStore.recentlyUploadedFiles.add(file);
        });
        modalStore.isReplaceMediaModalOpen = false;
        // modalStore.isUploadModalOpen = false;
        if (!modalStore.modalData.preventRefreshProject) {
            await projectStore.refreshProjectDetails();
        }
        if (modalStore.isMediaLibraryModalOpen) {
            modalStore.isMediaLibraryModalOpen = false;
            modalStore.isMediaLibraryModalOpen = true;
        }
    }

    async function saveFile(files, currentFiles, i) {
        try {
            const foldersPathArray = projectStore.mediaLibraryPathArray;
            const currentFolder = foldersPathArray[foldersPathArray.length - 1];
            const currentFolderId = currentFolder.folderId;
            let projectId;
            const {currentProject} = projectStore;
            const {currentProcedure} = procedureStore;
            if (currentProject && currentProject.ProjectIdentifier) {
                projectId = currentProject.ProjectIdentifier;
            } else if (currentProcedure && currentProcedure.ProjectRef) {
                projectId = currentProcedure.ProjectRef;
            } else {
                console.error('missing project ref');
                return;
            }
            const associatedFiles = await generalStore.uploadFiles(files, projectId, currentFolderId, null, generalStore.oldMediaFileToBeReplaced, i);
            if (generalStore.oldMediaFileToBeReplaced) {
                generalStore.newMediaFilesToBeReplaced.push(associatedFiles[0]);
                projectStore.setProceduresFromDB(projectId);
            }
            await onUploadFilesSuccess(associatedFiles);
            return associatedFiles;
        } catch (e) {
            console.error(e);
            if (e.response) {
                if (e.response.status === responseEnum.PAYLOAD_TOO_LARGE) {
                    modalStore.showErrorMessage(generalStore.translate('fileTooLarge2GB'));
                    return;
                } else if (e.response.status === responseEnum.NO_PERMISSION) {
                    modalStore.showErrorMessage(generalStore.translate('cannotUploadFileOfThisType'));
                    return;
                }
            }
            modalStore.showErrorMessage(generalStore.translate('problemUploadingFile'), true);
        }
    }

    return saveFile
};

export default SaveFileHook;